import React from "react";
import { toast } from 'react-toastify';
import BackToLogin from "../SignIn/BackToLogin";
import SignInFooter from "../SignIn/SignInFooter";
import LeftImageFortgotPassword from '../../components/SignIn/LeftImageFortgotPassword';
import { forgotPassword } from '../../api/authentication.api';
import { t } from "i18next";


const SentMail = ({ email }) => {

  const handleSubmit = async () => {
    try {
      const response = await forgotPassword({ email })

      toast.success(response?.message);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }

  };

  return (
    <div className='login-ary'>
      <section className='login-sec '>
        <div className='login-container '>
          <div className='container-fluid'>
            <div className='row bglogin'>
              <LeftImageFortgotPassword />
              <div className='col-xl-5 col-lg-6 col-sm-12 col-12 ttxt'>
                <div className="login-text">
                  <div className="text-center lgo-box cursor-pointer">
                    {/* <img src="/images/logo/Untitled-6.png" alt="logo" />  */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                    >
                      <path
                        d="M2.33301 8.16602L11.8587 14.834C12.6301 15.374 13.0158 15.644 13.4353 15.7485C13.8059 15.8409 14.1935 15.8409 14.564 15.7485C14.9836 15.644 15.3692 15.374 16.1406 14.834L25.6663 8.16602M7.93301 23.3327H20.0663C22.0265 23.3327 23.0066 23.3327 23.7553 22.9512C24.4139 22.6156 24.9493 22.0802 25.2849 21.4217C25.6663 20.673 25.6663 19.6929 25.6663 17.7327V10.266C25.6663 8.30583 25.6663 7.32574 25.2849 6.57705C24.9493 5.91848 24.4139 5.38305 23.7553 5.04749C23.0066 4.66602 22.0265 4.66602 20.0663 4.66602H7.93301C5.97282 4.66602 4.99273 4.66602 4.24404 5.04749C3.58547 5.38305 3.05004 5.91848 2.71448 6.57705C2.33301 7.32574 2.33301 8.30583 2.33301 10.266V17.7327C2.33301 19.6929 2.33301 20.673 2.71448 21.4217C3.05004 22.0802 3.58547 22.6156 4.24404 22.9512C4.99273 23.3327 5.97282 23.3327 7.93301 23.3327Z"
                        stroke="#344054"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <h2 className="text-center logtitle">{t("checkYourEmail")}</h2>
                  <p className="ms-2-message text-center">
                  {t("resetLinkTo")} <strong>{email}</strong>
                  </p>
                  <div>
                    <p className="">
                      <button type="submit" className="default-btn signinBtn mt-4 w-100">
                      {t("openEmailApp")}
                      </button>
                    </p>
                  </div>
                  <div className="don-have-account">
                  {t("receiveTheEmail")} <strong onClick={handleSubmit}>{t("clickToResend")}</strong>
                  </div>
                  <BackToLogin />
                  <SignInFooter />
                </div>
                <SignInFooter />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SentMail;
